import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

import { CookieConsentService } from '../../services/cookie-consent/cookie-consent.service';

@Component({
  selector: 'metall-rechner-cookie-consent-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatSnackBarModule],
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss']
})
export class CookieConsentBannerComponent {
  constructor(private snackbar: MatSnackBar, private cookieConsentService: CookieConsentService) {}

  accept() {
    this.cookieConsentService.accept();
    this.snackbar.dismiss();
  }

  decline() {
    this.snackbar.dismiss();
  }
}
